import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CoreApiService } from '../../../core/service/core-api-service';
import { AppService } from '../../../core/service/app.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { properties } from '../../../../environments/properties';
import { NotificationModel } from '../../../model/notification.model';
import { TooltipModule } from 'primeng/tooltip';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { JsonRequest } from '../../../model/jsonRequest.model';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-list',
  standalone: true,
  imports: [
    TableModule,
    ButtonModule,
    DividerModule,
    CommonModule,
    CalendarModule,
    FormsModule,
    TooltipModule,
    InputSwitchModule,
    DialogModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    ConfirmDialogModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './list.component.html',
  styleUrl: './list.component.css',
})
export class ListComponent implements OnInit {
  titulo: string = 'Lista de Notificaciones';
  dateStart: Date = new Date();
  dateEnd: Date = new Date();
  ltsNotifications: any[] = [];
  ltsStates: any[] = [];
  ltsChannels: any[] = [
    { id: 1, name: 'Conductores' },
    { id: 2, name: 'Clientes' },
    { id: 3, name: 'Todos' },
  ];
  dialogNotification: boolean = false;
  isCreate: boolean = false;
  tituloDialog: string = '';
  notificationSelected!: NotificationModel;
  formNotification = new FormGroup({
    not_id: new FormControl(0),
    not_title: new FormControl('', Validators.required),
    not_message: new FormControl('', Validators.required),
    not_political_division_id: new FormControl<number | null>(
      null,
      Validators.required,
    ),
    not_channel: new FormControl<number | null>(null, Validators.required),
  });

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
    private readonly confirmationService: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.dateStart.setDate(this.dateEnd.getDate() - 10);
    this.getListNotifications();
    this.getListPoliticalDivision();
  }

  openDialog(isCreate: boolean, notification: any): void {
    this.dialogNotification = true;
    this.isCreate = isCreate;
    if (isCreate) {
      this.tituloDialog = 'Crear Notificación';
      this.formNotification.reset();
    } else {
      this.tituloDialog = 'Editar Notificación';
      this.notificationSelected = notification;
      this.formNotification.patchValue(this.notificationSelected);
    }
  }

  cancel(): void {
    this.formNotification.reset();
    this.dialogNotification = false;
  }

  getChannelLabel(channel: number): string {
    switch (channel) {
      case 1:
        return 'Conductores';
      case 2:
        return 'Clientes';
      case 3:
        return 'Todos';
      default:
        return 'Desconocido';
    }
  }

  getListNotifications(): void {
    const queryParams = {
      startDate: this.dateStart?.toISOString().split('T')[0],
      endDate: this.dateEnd?.toISOString().split('T')[0],
    };
    this.apiService.consumirWSGet(
      properties.serviceListNotifications,
      queryParams,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.ltsNotifications = data.data;
        } else {
          this.util.mostrarToast(
            'Lista de notificaciones',
            'Error al obtener la lista de notificaciones',
            4,
          );
        }
      },
    );
  }

  getListPoliticalDivision(): void {
    this.apiService.consumirWSGet(
      properties.servicePoliticalDivisions,
      null,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.ltsStates = data.data;
        } else {
          this.util.mostrarToast(
            'Lista de Estados',
            'Error al obtener la lista de estados',
            4,
          );
        }
      },
    );
  }

  saveNotification(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        not_id: this.formNotification.value.not_id ?? 0,
        not_title: this.formNotification.value.not_title,
        not_message: this.formNotification.value.not_message,
        not_political_division_id:
          this.formNotification.value.not_political_division_id,
        not_channel: this.formNotification.value.not_channel,
        not_typ_notification: 1,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };

    this.apiService.consumirWSPost(
      properties.serviceCreateNotification,
      body,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.formNotification.reset();
          this.dialogNotification = false;
          this.getListNotifications();
          this.util.mostrarToast(
            'Crear Notificación',
            'Se ha creado la notificación',
            1,
          );
        } else {
          this.util.mostrarToast('Crear Compañia', 'Error al crear', 4);
        }
      },
    );
  }

  SendNotification(event: Event, notification: any): void {
    console.log('Enviar notificación: ', notification);
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Quieres enviar esta notificación?',
      header: 'Enviar Notificación',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        this.apiService.consumirWSGet(
          properties.serviceSendNotification + '/' + notification.not_id,
          null,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Enviar Notificación',
                'Se ha enviado la notificación',
                1,
              );
            } else {
              this.util.mostrarToast(
                'Enviar Notificación',
                'Error al enviar',
                4,
              );
            }
          },
        );
      },
      reject: () => {},
    });
  }
}
